import { Component, h, Host } from '@stencil/core';
import { theme } from '@eventstore-ui/theme';

/**
 * Displays Token illustration.
 * @part illustration - The root svg of the illustration.
 */
@Component({
    tag: 'es-illustration-token',
    styleUrl: 'token.css',
    shadow: true,
})
export class EsIllustrationToken {
    render() {
        const isDark = theme.isDark();

        return (
            <Host dark={isDark} light={!isDark}>
                {isDark ? this.renderDark() : this.renderLight()}
            </Host>
        );
    }

    renderLight() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enable-background="new 0 0 593 777.6"
                viewBox="0 0 593 777.6"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <linearGradient
                    id="token_SVGID_1_"
                    x1="889.746"
                    x2="461.306"
                    y1="-74.291"
                    y2="489.709"
                    gradientTransform="matrix(1 0 0 -1 -306 566.8)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#BBDEFB" />
                    <stop offset="1" stop-color="#FFF" />
                </linearGradient>
                <path
                    d="M590 513.8c0-183.7-114.1-398.4-254.8-479.6-69.3-40-132.1-40.2-178-8.2L88.1 64.8 103 95.5c-8 18.7-13.7 38.2-17.1 58.2l311.5 571.5c4.9 1.2 9.7 2.2 14.5 3l14.3 29.3 67-38.1 15.2-8.9c50.2-31.7 81.6-100.4 81.6-196.7z"
                    class="token_st0"
                />
                <path
                    d="m453.1 719.3-.5-.9L554 659.8l.6 1-101.5 58.5zM488.5 573.5l-.6-1L589.4 514l.5.9-101.4 58.6zM454.2 386.8l-.5-1 101.4-58.5.6.9-101.5 58.6zM360.3 211.1l-.6-.9 101.5-58.6.5 1-101.4 58.5zM233.2 94l-.5-.9 101.4-58.6.6 1L233.2 94z"
                    class="token_st1"
                />
                <path
                    d="M257.8 78.4C398.6 159.6 512.6 374.3 512.6 558s-114 266.7-254.8 185.4S3 447.5 3 263.8 117.1-2.9 257.8 78.4z"
                    class="token_st2"
                />
                <path
                    d="M439.3 279c-48.2-90.8-112.4-162.5-180.7-201.9-32.1-18.6-63.5-28.9-92.9-31v3.1c28.8 2 59.8 12.2 91.4 30.5 140.1 80.8 254 295.4 254 478.3 0 39.5-5.4 75.1-15.6 105.4l2.7 1.5c10.6-30.9 15.9-66.8 15.9-106.9 0-89.1-26.5-188.2-74.8-279z"
                    class="token_st3"
                />
                <path
                    d="M3 264.9v-1.1L512.6 558v1.1L3 264.9z"
                    class="token_st1"
                />
                <path
                    d="m36.9 118.2.5-.8 441.3 587.3-.4.7L36.9 118.2z"
                    class="token_st1"
                />
                <path
                    d="M130.1 50h.7l254.8 723h-.7L130.1 50z"
                    class="token_st1"
                />
                <path d="m257.4 78.7.8.5v665l-.8-.5v-665z" class="token_st1" />
                <path
                    d="m384.9 196.5.7 1-254.8 428.9-.7-1 254.8-428.9z"
                    class="token_st1"
                />
                <path
                    d="m478.3 371.9.4 1.2-441.3 77.8-.5-1.2 441.4-77.8z"
                    class="token_st1"
                />
                <path
                    d="M257.8 148c111.3 64.2 201.5 234 201.5 379.2s-90.2 210.9-201.5 146.6-201.5-234-201.5-379.2S146.6 83.7 257.8 148z"
                    class="token_st2"
                />
                <path
                    d="m59.1 272.6-3.9-2.1c-.5 7.8-.9 15.8-.9 24.1 0 52.8 11.8 110.1 33.8 165.7.4-.9 1.1-1.7 2-2.2l1.3-.6c-20.9-53.4-33.1-109.8-33.1-162.9 0-7.5.3-14.9.8-22zM258.8 146.2c-49.8-28.8-98-32.7-135.4-11.1-21.5 12.4-38.5 32.7-50.2 59l3.1 2.9c11.4-26.2 28-46.2 49.1-58.4 15.5-8.8 33.1-13.4 50.9-13.2 25.1 0 52.5 8.1 80.5 24.3 41.3 23.8 79.7 62.4 111.7 108.9l2.5-1c.3-.4.5-.9.8-1.4-33.1-48.2-72.1-86.4-113-110zM283.7 687.5v-3.1c-8.6-3.6-16.9-7.7-24.9-12.3-40.7-23.5-78.6-61.3-110.3-107-.3.4-.6.8-.8 1.2-.6.7-1.3 1.3-2.1 1.8 32.7 47 71.1 84.3 111.2 107.5 8.3 4.8 17 9 25.9 12.7l1-.8zM426.3 358.3l-.3.2-3.4 1.7c21.9 54.5 34.7 112.5 34.7 167 0 74.5-24.4 131.4-67 156-15.2 8.8-32.3 13.1-50.6 13.2.4 1.3.7 2.7 1.1 4 18.1 0 35.8-4.8 51.5-13.8 43.9-25.3 69-83.4 69-159.4 0-53.8-12.3-112.3-35-168.9z"
                    class="token_st3"
                />
                <path
                    d="M366.6 330.8c-17.2-32.3-37.9-55.5-62.2-69.5-16-9.2-30.7-12.6-44.2-10.2-13.5 2.4-24.2 10.2-32 23.3s-11.7 30-11.7 50.9c.1 12.9 1.6 25.8 4.5 38.4l-80.9 58.9c-2.4 1.7-3.5 4.8-3.5 9.1v50.8c0 4.6 1.2 9.1 3.5 13.1 1.8 3.9 4.8 7.2 8.5 9.5l55.9 32.3c3.3 1.9 6.2 2 8.5.3s3.5-4.7 3.5-9v-26.1l20 11.5c3.3 1.9 6.1 2.1 8.5.4s3.5-4.7 3.5-9.1v-26.1l18.4 10.7c3.7 2.1 6.7 2.1 9 0l12-10.7c5.2 4.3 10.7 8.1 16.5 11.5 24.3 14 45.1 14.8 62.2 2.3s25.7-34.6 25.7-66.3c0-31.7-8.6-63.7-25.7-96zm-38.2-3.5c6.6 3.8 12.3 10.2 17 18.9 4.4 8 6.8 17 6.9 26.2 0 8.7-2.3 14.8-6.9 18.2s-10.4 3.1-17-.7-12.4-10.2-17-18.9c-4.5-8-6.9-17-7-26.2 0-8.7 2.3-14.8 7-18.2s10.3-3.1 17 .7z"
                    class="token_st4"
                />
                <path
                    d="M335.2 34.2C265.9-5.8 203.1-6 157.2 26L88.1 64.8h0C35.9 95.7 3 165.2 3 263.8c0 183.7 114.1 398.4 254.8 479.6 66.8 38.6 127.6 40.1 173.1 11.5l74.9-42.7h0c51.7-31 84.2-100.4 84.2-198.4 0-183.7-114.1-398.4-254.8-479.6z"
                    class="token_st5"
                />
            </svg>
        );
    }

    renderDark() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0"
                y="0"
                enable-background="new 0 0 593 777.6"
                viewBox="0 0 593 777.6"
                aria-hidden="true"
                width="100%"
                height="100%"
                focusable="false"
                role="img"
                part="illustration"
            >
                <linearGradient
                    id="token_SVGID_1_"
                    x1="889.746"
                    x2="461.306"
                    y1="-74.291"
                    y2="489.709"
                    gradientTransform="matrix(1 0 0 -1 -306 566.8)"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0" stop-color="#09264A" />
                    <stop offset="1" stop-color="#CED4DB" />
                </linearGradient>
                <path
                    d="M590 513.8c0-183.7-114.1-398.4-254.8-479.6-69.3-40-132.1-40.2-178-8.2L88.1 64.8 103 95.5c-8 18.7-13.7 38.2-17.1 58.2l311.5 571.5c4.9 1.2 9.7 2.2 14.5 3l14.3 29.3 67-38.1 15.2-8.9c50.2-31.7 81.6-100.4 81.6-196.7z"
                    class="token_st0"
                />
                <path
                    d="m453.1 719.3-.5-.9L554 659.8l.6 1-101.5 58.5zM488.5 573.5l-.6-1L589.4 514l.5.9-101.4 58.6zM454.2 386.8l-.5-1 101.4-58.5.6.9-101.5 58.6zM360.3 211.1l-.6-.9 101.5-58.6.5 1-101.4 58.5zM233.2 94l-.5-.9 101.4-58.6.6 1L233.2 94z"
                    class="token_st1"
                />
                <path
                    d="M257.8 78.4C398.6 159.6 512.6 374.3 512.6 558s-114 266.7-254.8 185.4S3 447.5 3 263.8 117.1-2.9 257.8 78.4z"
                    class="token_st2"
                />
                <path
                    d="M439.3 279c-48.2-90.8-112.4-162.5-180.7-201.9-32.1-18.6-63.5-28.9-92.9-31v3.1c28.8 2 59.8 12.2 91.4 30.5 140.1 80.8 254 295.4 254 478.3 0 39.5-5.4 75.1-15.6 105.4l2.7 1.5c10.6-30.9 15.9-66.8 15.9-106.9 0-89.1-26.5-188.2-74.8-279z"
                    class="token_st3"
                />
                <path
                    d="M3 264.9v-1.1L512.6 558v1.1L3 264.9z"
                    class="token_st1"
                />
                <path
                    d="m36.9 118.2.5-.8 441.3 587.3-.4.7L36.9 118.2z"
                    class="token_st1"
                />
                <path
                    d="M130.1 50h.7l254.8 723h-.7L130.1 50z"
                    class="token_st1"
                />
                <path d="m257.4 78.7.8.5v665l-.8-.5v-665z" class="token_st1" />
                <path
                    d="m384.9 196.5.7 1-254.8 428.9-.7-1 254.8-428.9z"
                    class="token_st1"
                />
                <path
                    d="m478.3 371.9.4 1.2-441.3 77.8-.5-1.2 441.4-77.8z"
                    class="token_st1"
                />
                <path
                    d="M257.8 148c111.3 64.2 201.5 234 201.5 379.2s-90.2 210.9-201.5 146.6-201.5-234-201.5-379.2S146.6 83.7 257.8 148z"
                    class="token_st2"
                />
                <path
                    d="m59.1 272.6-3.9-2.1c-.5 7.8-.9 15.8-.9 24.1 0 52.8 11.8 110.1 33.8 165.7.4-.9 1.1-1.7 2-2.2l1.3-.6c-20.9-53.4-33.1-109.8-33.1-162.9 0-7.5.3-14.9.8-22zM258.8 146.2c-49.8-28.8-98-32.7-135.4-11.1-21.5 12.4-38.5 32.7-50.2 59l3.1 2.9c11.4-26.2 28-46.2 49.1-58.4 15.5-8.8 33.1-13.4 50.9-13.2 25.1 0 52.5 8.1 80.5 24.3 41.3 23.8 79.7 62.4 111.7 108.9l2.5-1c.3-.4.5-.9.8-1.4-33.1-48.2-72.1-86.4-113-110zM283.7 687.5v-3.1c-8.6-3.6-16.9-7.7-24.9-12.3-40.7-23.5-78.6-61.3-110.3-107-.3.4-.6.8-.8 1.2-.6.7-1.3 1.3-2.1 1.8 32.7 47 71.1 84.3 111.2 107.5 8.3 4.8 17 9 25.9 12.7l1-.8zM426.3 358.3l-.3.2-3.4 1.7c21.9 54.5 34.7 112.5 34.7 167 0 74.5-24.4 131.4-67 156-15.2 8.8-32.3 13.1-50.6 13.2.4 1.3.7 2.7 1.1 4 18.1 0 35.8-4.8 51.5-13.8 43.9-25.3 69-83.4 69-159.4 0-53.8-12.3-112.3-35-168.9z"
                    class="token_st3"
                />
                <path
                    d="M366.6 330.8c-17.2-32.3-37.9-55.5-62.2-69.5-16-9.2-30.7-12.6-44.2-10.2-13.5 2.4-24.2 10.2-32 23.3s-11.7 30-11.7 50.9c.1 12.9 1.6 25.8 4.5 38.4l-80.9 58.9c-2.4 1.7-3.5 4.8-3.5 9.1v50.8c0 4.6 1.2 9.1 3.5 13.1 1.8 3.9 4.8 7.2 8.5 9.5l55.9 32.3c3.3 1.9 6.2 2 8.5.3s3.5-4.7 3.5-9v-26.1l20 11.5c3.3 1.9 6.1 2.1 8.5.4s3.5-4.7 3.5-9.1v-26.1l18.4 10.7c3.7 2.1 6.7 2.1 9 0l12-10.7c5.2 4.3 10.7 8.1 16.5 11.5 24.3 14 45.1 14.8 62.2 2.3s25.7-34.6 25.7-66.3c0-31.7-8.6-63.7-25.7-96zm-38.2-3.5c6.6 3.8 12.3 10.2 17 18.9 4.4 8 6.8 17 6.9 26.2 0 8.7-2.3 14.8-6.9 18.2s-10.4 3.1-17-.7-12.4-10.2-17-18.9c-4.5-8-6.9-17-7-26.2 0-8.7 2.3-14.8 7-18.2s10.3-3.1 17 .7z"
                    class="token_st4"
                />
                <path
                    d="M335.2 34.2C265.9-5.8 203.1-6 157.2 26L88.1 64.8h0C35.9 95.7 3 165.2 3 263.8c0 183.7 114.1 398.4 254.8 479.6 66.8 38.6 127.6 40.1 173.1 11.5l74.9-42.7h0c51.7-31 84.2-100.4 84.2-198.4 0-183.7-114.1-398.4-254.8-479.6z"
                    class="token_st5"
                />
            </svg>
        );
    }
}
